import React, { ReactNode } from 'react';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { RegistMailComponentView } from './RegistMailComponentView';
import { WprViewError } from '../../wpr-framework/component/controls/WprViewError';
import { WprAnchor } from '../../wpr-framework/component/controls/WprAnchor';
import { withRouter } from 'react-router';
import { WprInput } from '../../wpr-framework/component/controls/WprInput';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';

/**
 * メール登録コンポーネント
 */
class RegistMailComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new RegistMailComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="done"><span>1</span></li>
								<li className="done"><span>2</span></li>
								<li className="done"><span>3</span></li>
								<li className="now">
									<span>4</span>
									<p className="conf double" id="step4">メールアドレス<br className="c-sm-br"/>の登録</p>							
								</li>
							</ul>
						</div>
					</div>
				</div>
				<main className="page-4a">
					<div className="input">
						<h2>
							お手続き用のURLをお送りするために、メールアドレスを登録ください
						</h2>
						<div className="c-input">
							<WprInput view={this.view} name="mailAddress" type="email" placeholder="例）zurich@example.com" id="id-mail-address"/>
							<WprViewError name="mailAddress" view={this.view} />
						</div>
						<div className="action-button">
							<WprButton view={this.view} name="sendMail" className="c-button">
								<WprSpan view={this.view} name="buttonName"></WprSpan>
							</WprButton>
						</div>
						<div className="description">
							<div className="warp">
								<p>
									本保険契約に関する個人情報は、チューリッヒ保険会社が保険引受の審査、本保険契約の履行のために利用するほか、チューリッヒ保険会社が他の商品・サービスの提供のために利用することがあります。
								</p>
								<p>
									また、上記の利用目的の達成に必要な範囲内で、業務委託先、保険金の請求・支払いに関する関係先、再保険会社などに提供することがあります。
								</p>
								<p className="security">
									詳しくは
									<a className="c-link" href="https://www.zurich.co.jp/agreement/" target="_blank">個人情報保護方針</a>
									をご確認ください。
								</p>
								<p>
									メールの受信時にドメイン・指定受信などの制限をかけている方は、保険会社からのメールが受信できるよう、
									<br />
									あらかじめ「@zurich.co.jp」からのメールが受信できるようご設定ください。
								</p>
							</div>
						</div>
						<div className="prev">
							<WprAnchor view={this.view} name="prev" className="c-btn-prev">
								<span>1つ前の画面に戻る</span>
							</WprAnchor>
						</div>
					</div>
				</main>
				<FooterComponent />
			</>
		);
	}
	// --------------------------------------------------------------------------
}

export default withRouter(RegistMailComponent);